import { render, staticRenderFns } from "./TransportDetail.vue?vue&type=template&id=364a2346&"
import script from "./TransportDetail.vue?vue&type=script&lang=js&"
export * from "./TransportDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransportDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports